
export enum Features {
  SHOW_SETTINGS = 'show-settings',
  EXPERIMENTAL_PB_FLAG = 'pb-flag-experimental',
  CONTACT_SUPPORT_LINK = 'contact-support-link',
  SHOW_MANIFEST_LOG = 'show-manifest-log',
  PB_COUNT_WINDSOR = 'pb-count-windsor',
  CUSTOM_SHIPMENT_GROUPS = 'custom-shipment-groups',
  WORKFLOWS = 'workflows',
  VENLO_TAG_FILTER = 'venlo-tag-filter',
  CUSTOMS_BROKER_AOT = 'customs-broker-aot',
}
